import angular from 'angular';
import BondRenewalWidgetComponent from './bond-renewal-widget-component';

export default angular.module('bond-renewal-widget', []).component('bondRenewalWidget', new BondRenewalWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/bond-renewal/bond-renewal-widget-module.js